/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

// IE CustomEvent polyfill
(function () {
  
  if ( typeof window.CustomEvent === "function" ) {
    return false;
  }
  console.log('hi');
  function CustomEvent ( event, params ) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent( 'CustomEvent' );
    evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
    return evt;
   }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
})();

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        //WebFontConfig = {
        //  google: { families: [ 'Open+Sans:400,600' ] }
        //};
        //(function() {
        //  var wf = document.createElement('script');
        //  wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1/webfont.js';
        //  wf.type = 'text/javascript';
        //  wf.async = 'true';
        //  var s = document.getElementsByTagName('script')[0];
        //  s.parentNode.insertBefore(wf, s);
        //})();
        
        // add custom media query sizes for Foundation Interchange
        Foundation.Interchange.SPECIAL_QUERIES.smallretina = 'only screen and (min-width: 1px) and (-webkit-min-device-pixel-ratio: 2), only screen and (min-width: 1px) and (min--moz-device-pixel-ratio: 2), only screen and (min-width: 1px) and (-o-min-device-pixel-ratio: 2/1), only screen and (min-width: 1px) and (min-device-pixel-ratio: 2), only screen and (min-width: 1px) and (min-resolution: 192dpi), only screen and (min-width: 1px) and (min-resolution: 2dppx)';
        Foundation.Interchange.SPECIAL_QUERIES.mediumretina = 'only screen and (min-width: 641px) and (-webkit-min-device-pixel-ratio: 2), only screen and (min-width: 641px) and (min--moz-device-pixel-ratio: 2), only screen and (min-width: 641px) and (-o-min-device-pixel-ratio: 2/1), only screen and (min-width: 641px) and (min-device-pixel-ratio: 2), only screen and (min-width: 641px) and (min-resolution: 192dpi), only screen and (min-width: 641px) and (min-resolution: 2dppx)';
        Foundation.Interchange.SPECIAL_QUERIES.largeretina = 'only screen and (min-width: 1025px) and (-webkit-min-device-pixel-ratio: 2), only screen and (min-width: 1025px) and (min--moz-device-pixel-ratio: 2), only screen and (min-width: 1025px) and (-o-min-device-pixel-ratio: 2/1), only screen and (min-width: 1025px) and (min-device-pixel-ratio: 2), only screen and (min-width: 1025px) and (min-resolution: 192dpi), only screen and (min-width: 1025px) and (min-resolution: 2dppx)';
        Foundation.Interchange.SPECIAL_QUERIES.xlargeretina = 'only screen and (min-width: 1921px) and (-webkit-min-device-pixel-ratio: 2), only screen and (min-width: 1921px) and (min--moz-device-pixel-ratio: 2), only screen and (min-width: 1921px) and (-o-min-device-pixel-ratio: 2/1), only screen and (min-width: 1921px) and (min-device-pixel-ratio: 2), only screen and (min-width: 1921px) and (min-resolution: 192dpi), only screen and (min-width: 1921px) and (min-resolution: 2dppx)';

        // add minimum checkbox validator for Foundation Abide
        Foundation.Abide.defaults.validators.checkbox_limit = function($el, required, parent) {
          var group = parent.closest('.checkbox-group');
          var min = group.attr('data-validator-min');
          var checked = group.find(':checked').length;
          if (checked >= min) {
            // clear label highlight
            group.find('label').each(function() {
              $(this).removeClass('is-invalid-label');
            });
            // clear checkbox error 
            group.find(':checkbox').each(function() {
              $(this).removeClass('is-invalid-input').removeAttr('data-invalid');
            });
            group.find('.form-error').hide();
            return true;
          } else {
            // label highlight
            group.find('label').each(function() {
              $(this).addClass('is-invalid-label');
            });
            // checkbox error 
            group.find(':checkbox').each(function() {
              $(this).addClass('is-invalid-input').attr('data-invalid');
            });
            group.find('.form-error').show();
            return false;
          }
        };

        // add plz pattern for Foundation Abide
        Foundation.Abide.defaults.patterns.plz = /^([0]{1}[1-9]{1}|[1-9]{1}[0-9]{1})[0-9]{3}$/;

        // add leap_year pattern for Foundation Abide
        Foundation.Abide.defaults.patterns.leap_year = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;

        // init Foundation JavaScript
        $(document).foundation(); 


        // set default Sticky size for Foundation Sticky
        Foundation.Sticky.defaults.stickyOn = 'large';

        // Mobile Menu
        Foundation.DropdownMenu.defaults.closeOnClick = true;       

        // check for alternative website logo
        if ($( ".website-logo-alt" ).length) {
          $('body').addClass('alt-logo');
        }

        // add no-touch class for desktop browsers
        var touchsupport = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);
        if (!touchsupport) { 
            document.documentElement.className += " no-touch ";
        }

        // check for IE/Edge
        if(/msie|trident|edge/g.test(navigator.userAgent.toLowerCase())) { 
           $('body').addClass('ie-edge');
           var version = navigator.userAgent.match( /(MSIE |Trident.*rv[ :])([0-9]+)/ ); 
           if(version != null) { 
               $('body').addClass('ie-ver-'+version[2]);
           } 

          $(".has-ie-fallback").each(function () {
            var $image = $(this);
            var fallback = $image.attr("data-ie-fallback");
            $image.attr("src", fallback);
          });
           
        }

        // show whatsApp Button
        if (Foundation.MediaQuery.is('small only')) {
          if( /windows phone|Android|webOS|iPhone|blackberry|Opera Mini/i.test(navigator.userAgent) ) {
           $('.whatsapp-share-button').css("display", 'inline-block');
          }
        }

        // handle scroll events
        var scrollTimer = null;
        $(window).scroll(function () {
          //if (scrollTimer) {
          //  clearTimeout(scrollTimer);   // clear any previous pending timer
          //}
          //scrollTimer = setTimeout(function() {
          //  scrollTimer = null;
            var currentScrollTop = $(window).scrollTop();
            var headerHeight = $('#main-header').outerHeight(true);
  
            // change body class on scroll
            if (currentScrollTop > 50) {
              $('body').addClass('solid-header');
            } else {
              $('body').removeClass('solid-header');
            }       
  
            if ((Foundation.MediaQuery.atLeast('large')) && ($( ".top-scroller" ).length)) {
              if ($( ".top-scroller.slideable" ).length) {
                if (currentScrollTop > headerHeight) {  
                  $( ".top-scroller" ).removeClass('hidden').addClass('sticky').addClass('slide-in-down');                
                } else {
                  $( ".top-scroller" ).removeClass('slide-in-down').removeClass('sticky').addClass('hidden');
                }
              } else {
                if (currentScrollTop > headerHeight) {  
                  $('.top-scroller').addClass('sticky');
                } else {
                  $('.top-scroller').removeClass('sticky');
                }
              }           
            }
    
          //}, 100);   // set new timer
        });

        $('.top-scroller-img-wrap').click(function(){
          $('html, body').animate({
              scrollTop: 0
          }, 300);            
        }); 

        // Toggle menu
        $('[data-off-canvas]').on("opened.zf.offcanvas", function(e) {
          $('#toggle-menu').addClass('open');
          if ($(this).hasClass('full')) {
            $('body').addClass('full-off-canvas');
          }
          $('#main-header').addClass('toggle-menu-open');
          $('body').addClass('no-scroll toggle-menu-open');
          $('#toggle-menu-button').addClass('active');
        });
        $('[data-off-canvas]').on("closed.zf.offcanvas", function(e) {
          $('#toggle-menu').removeClass('open');
          $('#main-header').removeClass('toggle-menu-open');
          $('body').removeClass('no-scroll toggle-menu-open');
          $('#toggle-menu-button').removeClass('active');          
        });

        $('#toggle-menu .menu-item-has-children > a').click(function(){
           var i = 0;
           var parent = $(this).parent();
           $('#toggle-menu ul > li').each(function(){
             if($('#toggle-menu ul > li').index(parent)!==i){
               $(this).removeClass('open');
               $(this).find('*').removeClass('open');
             }
             i++;
           });
           $(this).parent().toggleClass('open');
           $(this).toggleClass('open');
           $(this).siblings('.foldable-content').toggleClass('open');
           return false;
        });     
        
        $('.off-canvas').on('scroll', function () {
          if ($(this).scrollTop() > 0) {
            $('#main-header').addClass('toggle-menu-scrolled');
          } else {
            $('#main-header').removeClass('toggle-menu-scrolled');
          }
        });   

        // Dropcaps
        $('.single-post .text-content-wrap:first-child p:first-child').each(function() {
          var text = $.trim($(this).text());
          var first_letter = text.substr(0,1);
          if ($(this).parent().is( "blockquote" ) ) {
            //console.log("blockquote");
          } else {
            $(this).html('<span class="dropcap">' + first_letter + '</span>' + text.slice(1));
          }
        }); 

        // Smooth scrolling
        if(window.location.hash) {
          $('html, body').animate({
              scrollTop: $(window.location.hash).offset().top - $('#main-header').height() + 'px'
          }, 1000);
        }         

        // Scrolldown Button scrolling
        $('.scrolldown-button').click(function(){
          var nextSection = $(this).closest('section').next();

          $('html, body').animate({
              scrollTop: nextSection.offset().top
          }, 1000);            
        });

        // Search
        function initSearch() {
          $('.search-bar .search-form .search-button').on('click', function(e) {
            e.preventDefault();
            $('body').addClass('search-bar-open');
            $('.navbar-nav').addClass('search-bar-active');
            $('.search-bar .search-form .search-input').focus();
            $('.search-bar .search-form .search-input').keypress(function (e) {
              if (e.which === 13) {
                $(this).parents('form').submit();
                return false;
              }
            });
          });
          $('.search-bar .search-form .search-close').on('click', function(e) {
            e.preventDefault();
            $('.search-bar .search-input').blur();
            $('body').removeClass('search-bar-open');
            $('.navbar-nav').removeClass('search-bar-active');
          });
          $('.toggle-menu-overlay').on('click', function(e) {
            e.preventDefault();
            $('.search-bar .search-form .search-input').blur();
            $('body').removeClass('search-bar-open');
            $('.navbar-nav').removeClass('search-bar-active');
          });  

          $('.search-toggle-menu .search-form .search-button').on('click', function(e) {
            e.preventDefault();
            $(this).parents('form').submit();
            return false;
          });           
          $('.search-toggle-menu .search-input').keypress(function (e) {
            if (e.which === 13) {
              $(this).parents('form').submit();
              return false;
            }
          });                           
        }

        initSearch(); 

        // Cookie functions
        function createCookie(name, value, days) {
          var expires = "";
            if (days) {
              var date = new Date();
              date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
              expires = "; expires=" + date.toGMTString();
            } else {
              expires = "";
            }
            document.cookie = name + "=" + value + expires + "; path=/";
        }
        
        function readCookie(name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) === ' ') {
                  c = c.substring(1, c.length);
                }
                if (c.indexOf(nameEQ) === 0) {
                  return c.substring(nameEQ.length, c.length);
                }
            }
            return null;
        }
        
        function eraseCookie(name) {
            createCookie(name, "", -1);
        }


        // If cookie-notice cookie is not set, show .new-cookie-notice
        if ((!readCookie('cookie-notice')) && (!$('body').hasClass('iframe'))) {
            $('.new-cookie-notice').show();
        } else {
            $('.new-cookie-notice').hide();
        }
    
        // Add the event that closes the popup and sets the cookie to not show again until 3650 days have passed.
        $('#close-cookie-notice').click(function(){
          $(".new-cookie-notice").slideUp(150);
          createCookie('cookie-notice', true, 3650);
          return false;
        });   

        // welcome-box-section cookie
        if ((!readCookie('welcome-box-section-closed')) && (!$('body').hasClass('iframe'))) {
            $('.welcome-box-section').show();
            $('.welcome-box-teaser').show();
        } else {
            $('.welcome-box-section').hide();
            $('.welcome-box-teaser').hide();
        }

        $( ".close-welcome-box-section-button" ).click(function() {
          var $closeSection = $(this).closest('.welcome-box-section');
          var $closeBox = $(this).closest('.welcome-box-teaser');
          $closeSection.slideUp(300);
          $closeBox.slideUp(300);
          createCookie('welcome-box-section-closed', true, 3650);
          return false;          
        });

        // info-box-section cookie
        if ((!readCookie('info-box-section-closed')) && (!$('body').hasClass('iframe'))) {
            $('.info-box-section').show();
            $('.info-box-teaser').show();
        } else {
            $('.info-box-section').hide();
            $('.info-box-teaser').hide();
        }

        $( ".close-info-box-section-button" ).click(function() {
          var $closeSection = $(this).closest('.info-box-section');
          var $closeBox = $(this).closest('.info-box-teaser');
          $closeSection.slideUp(300);
          $closeBox.slideUp(300);
          createCookie('info-box-section-closed', true, 3650);
          return false;          
        });                          

        // Custom wpml cookie
        if (SiteParameters.wpml_current_lang && SiteParameters.activate_custom_browser_redirect) {
          $('.wpml-ls-link').click(function(){
            var setLang = $(this).attr('data-lang');
            createCookie('language_switcher_was_used', setLang, 365);
          });           
        }  
        
        // Forms
        function bind_validation_handlers(form){
          var $this = form;
          var formIndex = $this.attr('data-form-index');
          var formType = $this.attr('data-form-type');

          $this.bind("submit",function(e) {
            e.preventDefault();
            //console.log("submit intercepted");
            return false;
          });
                              
          $this.bind("invalid.zf.abide", function(ev,elem) {
            //console.log("Field "+elem.attr('name')+" is invalid");
            if (elem.is('[type="text"]') || elem.is('[type="email"]')) {
              var inputText = elem.val();
              var $inputErrorRequired = elem.siblings('.form-error').not('.form-error-pattern');
              var $inputErrorPattern = elem.siblings('.form-error-pattern');
              if ($inputErrorPattern.length) {
                if (inputText.length) {
                  $inputErrorRequired.removeClass('is-visible');
                  $inputErrorPattern.addClass('is-visible');
                } else {
                  $inputErrorPattern.removeClass('is-visible');
                  $inputErrorRequired.addClass('is-visible');                  
                }               
              }
            }    
          });

          $this.bind("valid.zf.abide", function(ev,elem) {
            //console.log("Field "+elem.attr('name')+" is valid");
            $this.foundation('removeErrorClasses', elem);     
          });
          $this.bind("forminvalid.zf.abide", function(e,target) {
            //console.log("form is invalid");
            var invalidFields = $this.find('[data-invalid]');
            if (invalidFields) {
              var $firstInvalidField = $this.find('[data-invalid]').first();
              if (invalidFields) {
                $('html,body').animate({
                  scrollTop: $firstInvalidField.offset().top - 100
                }, 500); 
              }
            }            
          });

          $this.on("formvalid.zf.abide", function(ev,frm) {
            var formData;

            formData = 'action=standardFormAction&post_id=' + SiteParameters.post_id +'&form_index=' + formIndex +'&form_type=' + formType + '&' + $this.serialize();
            $.ajax({
              url: SiteParameters.ajax_url,
              type: 'POST',
              dataType: 'JSON',
              data: formData,
              beforeSend: function () {
                //console.log('beforeSend');               
              },
              error: function (data) {
                console.log('error function fired');
                console.log('message:' + data.message);
              },
              success: function (data) {
                if (data.status === 'success') {
                  $('.standard-form-' + formIndex).hide();
                  $('.standard-form-' + formIndex).next('#thank-you-message').fadeIn(300);                
                  $(window).trigger('resize');

                } else {
                  console.log('success error');
                }
                console.log('message:' + data.message);
              },
              complete: function() {
                //console.log('Complete');
              }
            });
            return false; 
          });          
        } 

        $('.standard-form').each(function(idx, item) {
          var $this = $(this);
          bind_validation_handlers($this);
        });           

        // Reinit abide and validation
        function reinit_abide_and_validation(){
          Foundation.reInit('abide');
          $('.standard-form').each(function(){
            var $this = $(this);
            bind_validation_handlers($this);
          }); 
        }

        // Set input required atts for dynamic-element(s)
        function set_required_fields(){
          $('.form-sub-group.cloned-field input').each(function(){
             $(this).prop("required", true);
          }); 
        } 

        //Clone the first dynamic-element and insert it
        function clone_first_dynamic_element(){
          $('.dynamic-element').first().clone().insertBefore('.add-sub-group-button').addClass('cloned-field').show().removeAttr('style');
          set_required_fields();
          reinit_abide_and_validation();
        }
        if ($('.dynamic-element').length) {
          clone_first_dynamic_element();
        }        
        
        // Attach functionality to remove buttons
        function attach_remove(){
          $('.remove-sub-group-button').off();
          $('.remove-sub-group-button').click(function(){
            $(this).closest('.form-sub-group').remove();
          });
        }        

        // Clone the other dynamic-elements on button click
        $('.add-sub-group-button').click(function(){
          var $dynamicElement = $('.dynamic-element').first().clone().insertBefore('.add-sub-group-button').addClass('cloned-field').show().removeAttr('style');
          var $removeButton = $('.remove-sub-group-button').first().clone().show().removeAttr('style');
          $dynamicElement.append($removeButton);
          set_required_fields();
          reinit_abide_and_validation();           
          attach_remove();
        });

        // Handle checkbox changes
        $('#other-checkbox input').change(function(){
          if ($(this).is(':checked')) {
            $('#other-checkbox-target').addClass('hidden');
            $('.toggle-check').each(function(){
               $(this).prop("checked", false);
            });    
            $('.form-sub-group.cloned-field').each(function(){
               $(this).remove();
            });            
          } else {
            $('#other-checkbox-target').removeClass('hidden');  
            if ($('.form-sub-group.cloned-field').length === 0) {
              clone_first_dynamic_element();
            }          
          }    
          reinit_abide_and_validation();  
        }); 

        $('.toggle-check').change(function(){
          if ($(this).is(':checked')) {
            $('#other-checkbox input').prop("checked", false).change();           
          }      
        });         
        
        // Helper function
        function daysInMonth(month, year) {
          return new Date(year, month, 0).getDate();
        }

        // Update the days based on the current values of month and year
        function updateNumberOfDays(){
        
          if ($('.months').val() !== '') {
            month = $('.months').val();
          } else {
            month = 1;
          }
          if ($('.years').val() !== '') {
            year = $('.years').val();
          } else {
            year = new Date().getFullYear();
          }          
          
          last = $('.days option').last().val();
          days = daysInMonth(month, year);

          if (last > days) {
            while (last > days) {
              $('.days').children(":last").remove(); 
              last--;
            }
          } else if (last < days ) {
            while (last < days) {
              var dateIndex = parseInt(last) + 1; 
              var number = (dateIndex < 10) ? "0"+dateIndex: dateIndex;
              $('.days').append($('<option />').val(number).html(number));
              last++;
            }
          }                   

        }

        // Populate years select box
        for (i = new Date().getFullYear(); i > 1900; i--){
          $('.years').append($('<option />').val(i).html(i));
        }
        // Populate months select box
        for (i = 1; i < 13; i++){
          number = (i < 10) ? "0"+i: i;
          $('.months').append($('<option />').val(number).html(number));
        }
        // Populate Days select box
        for (i = 1; i <= 31; i++) {
          number = (i < 10) ? "0"+i: i;
          $('.days').append($('<option />').val(number).html(number));
        }
    
        // Handle change events
        $('.years, .months').change(function(){
          updateNumberOfDays(); 
        });



        // fire initial resize
        $(window).trigger('resize');

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired  
       
      },
      resize: function() {

        var headerHeight = $('#main-header').outerHeight(true);
        var footerHeight = $("#footer-wrap").outerHeight(true);
        var windowHeight = $(window).height();
        var combinedHeight = windowHeight - headerHeight - footerHeight;

        // Sync heights
        function equalHeight(group) {
          var tallest = 0;
          group.css('height','auto'); //otherwise only works once!
          group.each(function() {
            var thisHeight = $(this).outerHeight(true);
            if(thisHeight > tallest) {
              tallest = thisHeight;
            }
          });
          group.height(tallest);      
        } 

        // check for external links
        function checkForExternalLinks() {
          $('a').each(function() {
            var currentHref = this.href;

            if( location.hostname === this.hostname || !this.hostname.length ) {
              if (!$(this).hasClass('local')) {
                $(this).addClass('local');
              }
            } else {
              if (!$(this).hasClass('external')) {
                if (!$(this).hasClass('whatsapp-share-button')) {
                  $(this).addClass('external');
                  if ($('#external-link-popup').length) {
                    $(this).attr("data-open", 'external-link-popup' );
                    $(this).click( function( e ) {
                        e.preventDefault();
                        e.stopPropagation();
                        $('#external-link-popup').foundation('open');
                        $('#external-link-popup .leave-site').attr("href", currentHref );
                    });
                  }
                }
              }              
            }
          });
        }
        checkForExternalLinks();

        // ie object-fit fallback
        function checkForIE() {
          var userAgent = window.navigator.userAgent;
          var ieReg = /msie|Trident.*rv[ :]*11\./gi;
          var ie = ieReg.test(userAgent);
          
          if(ie || (CSS.supports("object-position: center") === false)) {
            $(".image-wrap.aspect-ratio").each(function () {
              var $container = $(this);
              var imgUrl = $container.find("img").prop("src");
              var imgPos = $container.find("img").attr("data-object-position");
              var bgVideo = $container.find(".background-video");
              if (imgUrl) {
                $container.css("backgroundImage", 'url(' + imgUrl + ')').addClass("ie-object-fit");
                if (imgPos) {
                  $container.css("background-position", imgPos);
                }                
              }
              if (bgVideo) {
                $container.addClass("ie-object-fit-video");             
              }              
            });
          }                          
        }
        checkForIE();

        // Sliders
        var resizeSliders = null;

        clearTimeout(resizeSliders);
        resizeSliders = setTimeout(
          function() {
            function renderCounter(slick,sliderId) {
              var slidesToShow;
              if(slick.activeBreakpoint!==null){
                slidesToShow = slick.breakpointSettings[slick.activeBreakpoint].slidesToShow;
              } else {
                slidesToShow = slick.options.slidesToShow;
              }
    
              if($('#'+sliderId).parents('.slider-wrapper').find('.slick-next').length>0){
                $('#'+sliderId).parents('.slider-wrapper').find('.counter').html( (slick.currentSlide+slidesToShow)/slidesToShow +' / ' + Math.ceil((slick.slideCount)/slidesToShow));
                $('#'+sliderId).parents('.slider-wrapper').find('.slider-control').show();
              } else {
                $('#'+sliderId).parents('.slider-wrapper').find('.counter').html('');
                $('#'+sliderId).parents('.slider-wrapper').find('.slider-control').hide();
              }
            } 
    
            $('.common-slider').each(function (idx, item) {
              if ($(this).hasClass('slick-initialized')) {
                  $(this).slick('resize');
              } else {
                var sliderId = "slider_" + idx;
                this.id = sliderId;
                $(this).attr('data-counter','slider_slick-control_' + idx);
                $(this).next('.slider-control').attr('id','slider_slick-control_' + idx);
                
                $(this).on('init', function(event, slick) {
                  //console.log('init');
                });

                $(this).on('reInit', function(event, slick){
                  //console.log("reInit");
                });
  
                $(this).on('setPosition', function(event, slick) {
                  //console.log('setPosition');
                  renderCounter(slick,sliderId);
                });

                $(this).on('beforeChange', function(event, slick, currentSlide, nextSlide){
                  //console.log(nextSlide);
                });  

                $(this).on('afterChange', function(event, slick, currentSlide){
                  //console.log(currentSlide);
                });  

                $(this).on('edge', function(event, slick, direction){
                  //console.log('edge was hit');
                });                          
    
                $(this).slick({
                  appendArrows: $('#slider_slick-control_' + idx)                  
                });

              }
            });            

          },
          400
        );              

        // Load ajax posts
        function load_ajax_posts () {
            var settingsKey = $(this).attr('data-posts-selector-index');
            var currentPostID = $(this).attr('data-posts-selector-current-post-id');

            var currentHowManyPosts = $(this).attr('data-posts-selector-how-many-posts');
            var currentNumRowsMobile = $(this).attr('data-posts-selector-num-rows-mobile');
            var currentNumRowsDesktop = $(this).attr('data-posts-selector-num-rows-desktop');

            var currentButtonColor = $(this).attr('data-posts-selector-button-color');
            var currentButtonText = $(this).attr('data-posts-selector-button-text');
            var currentCustomVars = $(this).attr('data-posts-selector-custom-vars');
      
            var currentPostCount = $(this).find('.load-more').attr('data-load-more-current-post-count');
            var currentOffset = $(this).find('.load-more').attr('data-load-more-current-offset');
            
            var currentPostsPerPage = -1; 
            var currentMediaquery = '';
            
            if (currentHowManyPosts !== 'all') {
              if (Foundation.MediaQuery.is('small only')) {
                  currentPostsPerPage = currentNumRowsMobile;
              }
              if (Foundation.MediaQuery.is('medium only')) {
                  currentPostsPerPage = currentNumRowsDesktop * 3;
              }
              if (Foundation.MediaQuery.is('large only')) {
                  currentPostsPerPage = currentNumRowsDesktop * 3;
              }
              if (Foundation.MediaQuery.atLeast('xlarge')) {
                  currentPostsPerPage = currentNumRowsDesktop * 3;
              }
              if (Foundation.MediaQuery.atLeast('xxlarge')) {
                  currentPostsPerPage = currentNumRowsDesktop * 4;
              }              
            }

            if (currentHowManyPosts === 'home') {
              if (Foundation.MediaQuery.is('small only')) {
                  currentPostsPerPage =  -1;
              } 
              if (Foundation.MediaQuery.is('medium only')) {
                  currentPostsPerPage =  -1;
              }
              if (Foundation.MediaQuery.atLeast('large')) {
                  currentPostsPerPage = currentNumRowsDesktop;
              }
            }
      
            if (Foundation.MediaQuery.is('small only')) {
                currentMediaquery = 'small';
            }
            if (Foundation.MediaQuery.is('medium only')) {
                currentMediaquery = 'medium';
            }
            if (Foundation.MediaQuery.is('large only')) {
                currentMediaquery = 'large';
            }
            if (Foundation.MediaQuery.atLeast('xlarge')) {
                currentMediaquery = 'xlarge';
            }      
            if (Foundation.MediaQuery.atLeast('xxlarge')) {
                currentMediaquery = 'xxlarge';
            }             
            
            if ( !($('.posts-selector-multiple-' + settingsKey).hasClass('loader-loading')) ) {
            
              $.ajax({
                type: "GET",
                url: SiteParameters.ajax_url,
                dataType: 'html',
                data: ({
                  action: 'load_responsive_posts',
                  currentsettingskey: settingsKey,
                  currentpostid: currentPostID,
                  currentpostsperpage: currentPostsPerPage,
                  currentbuttoncolor: currentButtonColor,
                  currentbuttontext: currentButtonText,
                  currentcustomvars: currentCustomVars,
                  currentmediaquery: currentMediaquery,
                  currentpostcount: currentPostCount,
                  currentoffset: currentOffset
                }),
                beforeSend : function () {
                  $('.posts-selector-multiple-' + settingsKey).addClass('loader-loading');
                },              
                success: function(data) {
                  if(data) {
                    if ( $('#load-more-' + settingsKey).length > 0 ) {
                      $('#load-more-' + settingsKey).closest('.more-button-wrap').replaceWith("<div class='new-data grid-x grid-margin-x' style='position: relative;'>" + data + "</div>");                     
                      $('.posts-selector-multiple-' + settingsKey).find('.new-data').append( $('.posts-selector-multiple-' + settingsKey).closest('section').find('.load-wrapper') );
                      $('.posts-selector-multiple-' + settingsKey).closest('section').find('.load-wrapper').removeClass('loading-complete');
                    } else {
                      $('.posts-selector-multiple-' + settingsKey).prepend(data);
                    }

                    var itemCount = 0;
                    if (currentPostCount) {
                      itemCount = currentPostCount;
                    }
                    var itemLength = $('.posts-selector-multiple-' + settingsKey + ' .post-item').length;
                    $('.posts-selector-multiple-' + settingsKey + ' .post-item').each(function(){ 
                      var $this = $(this);
                      $this.attr("data-equalizer-watch", 'posts-selector-' + settingsKey ); 
                      var $cardImage = $this.find('.card-image');
                      if ($cardImage.length) {
                        $cardImage.on("replaced.zf.interchange", function() {
                          $cardImage.on('load', function() {
                              itemCount++;
                              if (itemCount === itemLength) {
                                $('.posts-selector-multiple-' + settingsKey).closest('section').find('.load-wrapper').addClass('loading-complete');
                                if ( $('.posts-selector-multiple-' + settingsKey).closest('section').find('.load-wrapper').parent().hasClass('new-data') ) {
                                  $('.posts-selector-multiple-' + settingsKey).closest('section').find('.load-wrapper').unwrap();
                                }
                              }                            
                          });                     
                        });  
                        $this.find('.card-image').not('[data-resize]').foundation();  
                      } else {
                        itemCount++;
                        if (itemCount === itemLength) {
                          $('.posts-selector-multiple-' + settingsKey).closest('section').find('.load-wrapper').addClass('loading-complete');
                          if ( $('.posts-selector-multiple-' + settingsKey).closest('section').find('.load-wrapper').parent().hasClass('new-data') ) {
                            $('.posts-selector-multiple-' + settingsKey).closest('section').find('.load-wrapper').unwrap();
                          }
                        }                                            
                      }
                    }); 

                    if ( $('.posts-selector-multiple-' + settingsKey).hasClass('posts-selector-equalize') ) {
                      Foundation.reInit('equalizer');                     
                    }

                    checkForExternalLinks();
                    checkForIE();

                  } else {
                    console.log("no data");
                  }
                },
                error: function(data) {
                  console.log("Error: " + data);
                  return false;
                },
                complete:   function() {    
                  $('.posts-selector-multiple-' + settingsKey).removeClass('loader-loading');          
                  // Trigger event after the posts are loaded
                  var parentSectionIndex = $('.posts-selector-multiple-' + settingsKey).closest('section').attr('data-section-index');
                  var loadResponsivePostsCompleteEvent = new CustomEvent('loadResponsivePostsComplete', {
                    'detail': {"parentsectionindex":parentSectionIndex}
                  });
                  document.dispatchEvent(loadResponsivePostsCompleteEvent);                         
                }           
              });
            }
        }            

        var resizeMorePosts = null;

        clearTimeout(resizeMorePosts);
        resizeMorePosts = setTimeout(
          function() {
            $('.posts-selector-multiple .post-item').each(function(){
              $(this).remove(); 
            });  
            $('.posts-selector-multiple .load-more').each(function(){
              $(this).remove(); 
            });                      
            $.each($('.posts-selector-multiple'), load_ajax_posts);      
          },
          400
        ); 
              
        $(".posts-selector-multiple").on('click', 'button.load-more', function() {
          var currentParent = $(this).closest('.posts-selector-multiple');
          $.each(currentParent, load_ajax_posts);
        });        

        document.addEventListener('loadResponsivePostsComplete', function(e) {
          //console.log("loadResponsivePostsComplete parentSectionIndex: " + e.detail.parentsectionindex);     
        }, false); 

        // set height of head-section
        $('.head-section').not('.style-standard').not('.post-head-section').each(function(){
          var headSectionImageHeight = $(this).find('.image-wrap').outerHeight(true); 
          var headSectionHeadlineWrapHeight = $(this).find('.section-headline-wrap').outerHeight(true);
          var scrollDownButtonHeight = $(this).find('.scrolldown-button').outerHeight(true);
          var imageHeadSectionMinHeight = headSectionImageHeight + headSectionHeadlineWrapHeight + scrollDownButtonHeight + 120;
          var imageHeadSectionMaxHeight = windowHeight - headerHeight;

          if ((Foundation.MediaQuery.atLeast('large')) && ((windowHeight < 1000) || (headSectionImageHeight > imageHeadSectionMaxHeight))) {
            $(this).find('.image-wrap').css({'height': windowHeight - headerHeight});
            $(this).find('.scrolldown-button').css({'display': 'block'});
            if ($(this).find('.wp-caption-text').length) {
              var captionTextHeight = $(this).find('.wp-caption-text').outerHeight(true);
              $(this).find('.scrolldown-button').css({'bottom': captionTextHeight + 20 + "px"});
            }          
          } else {
            $(this).find('.image-wrap').css({'height': 'auto'});
            $(this).find('.scrolldown-button').css({'display': 'none'});
          } 
        });            

        // Sticky footer
        function stickyFooter() {
          if (Foundation.MediaQuery.atLeast('large')) {
            $("main.main").css('min-height', combinedHeight + "px");
          } else {
            $("main.main").css('min-height', "100vh");          
          }                    
        }

        if ($( "#footer-wrap" ).length) {
          stickyFooter();
        }       

      },
      windowload: function() {
        //console.log('loaded');

        $('html').addClass('window-loaded');      
        
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS

      },
      resize: function() {

      },
      windowload: function() {

      }
    },
    'page_template_template_layouts': {
      init: function() {

      },
      finalize: function() {

      },
      resize: function() {

      },
      windowload: function() {

      }
    }    
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
        //UTIL.fire(classnm, 'resize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
      //UTIL.fire('common','resize');
    },
    resizeEvents: function() {

      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'resize');
      });

      UTIL.fire('common','resize');

    },
    windowLoadEvents: function() {

      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm, 'windowload');
      });

      UTIL.fire('common','windowload');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
  $(window).on("load",UTIL.windowLoadEvents);

  // Resize Events
  var trackWindowWidth = $(window).width();

  $(window).resize(function (trackResizeEvent) {
      //console.log(!trackResizeEvent.isTrigger ? ' resize' : ' triggerd');
  
      // Check window width has actually changed and it's not just iOS triggering a resize event on scroll || the resize event was caused by $(window).trigger('resize');
      if (($(window).width() !== trackWindowWidth) || trackResizeEvent.isTrigger) {
          // Update the window width for next time
          trackWindowWidth = $(window).width();

          UTIL.resizeEvents();
      }  
  });


})(jQuery); // Fully reference jQuery after this point.

